import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Signup = ({ showAlert }) => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  let navigate = useNavigate();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/createuser`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        name: formData.name,
        email: formData.email,
        password: formData.password,
      }),
    });
    const json = await response.json();
    console.log(json);
    if (json.success) {
      //redirect
      showAlert({
        type: "success",
        title: "Success",
        message: "Account created Successfully.",
      });
      localStorage.setItem("token", json.authtoken);
      localStorage.setItem("name", formData.name);
      navigate("/login");
    } else {
      showAlert({
        type: "error",
        title: "Error",
        message: "email already exist.",
      });
    }
  };

  const handleLink = () => {
    navigate("/login");
  };

  const CloudIcon = () => (
    <svg
      style={{ height: "30px", width: "30px", color: "#eab308" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z"></path>
    </svg>
  );

  return (
    <div style={styles.container}>
      {/* Logo + Title + Tagline */}
      <div style={{ textAlign: "center", margin: "0 10px 10px 0" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <div>
            <CloudIcon />
          </div>
          <h1 style={styles.heading}>MinDrop</h1>
        </div>
        <p style={styles.tagline}>Your thoughts, safely stored in the cloud</p>
      </div>

      {/* Form */}
      <div style={styles.formWrapper}>
        <form style={styles.formBox} onSubmit={handleSubmit}>
          <h2 style={styles.title}>Create account</h2>
          <p style={styles.subtitle}>
            Join MinDrop and start organizing your thoughts.
          </p>

          <label style={styles.label}>Full Name</label>
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            style={styles.input}
            required
          />

          <label style={styles.label}>Email</label>
          <input
            type="email"
            name="email"
            placeholder="you@gmail.com"
            value={formData.email}
            onChange={handleChange}
            style={styles.input}
            required
          />

          <label style={styles.label}>Password</label>
          <div style={styles.passwordWrapper}>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              placeholder="Enter your Password"
              value={formData.password}
              onChange={handleChange}
              minLength={5}
              style={{ ...styles.input, marginBottom: 0 }}
              required
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={styles.icon}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>

          <button type="submit" style={styles.button}>
            Sign Up
          </button>
          <div style={styles.subtitlefooter}>
            <p>
              Already have an account?
              <button
                className="btn btn-link"
                onClick={handleLink}
                style={{
                  all: "unset",
                  cursor: "pointer",
                  color: "#eab308",
                  marginLeft: "5px",
                  textDecoration: "underline",
                }}
              >
                Login
              </button>
            </p>
          </div>
        </form>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <p className="mb-2">MinDrop features:</p>
        <div style={styles.footerIcons}>
          <span>📁 Organized Notes</span>
          <span>🔐 Secure Storage</span>
          <span>☁️ Cloud Sync</span>
          <span>⚡ Fast Search</span>
        </div>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    backgroundColor: "#FFFDEA",
    minHeight: "97vh",
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  heading: {
    fontSize: "32px",
    fontWeight: "bold",
    color: "#111827",
    margin: 0,
  },
  tagline: {
    fontSize: "0.9rem",
    color: "rgb(75, 85, 99)",
    marginTop: "5px",
  },
  formWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  formBox: {
    width: "100%",
    maxWidth: "440px",
    minHeight: "480px", // increased height
    padding: "24px",
    backgroundColor: "white",
    borderRadius: "12px",
    boxShadow: "0 8px 15px rgba(0, 0, 0, 0.1)",
  },
  title: {
    textAlign: "center",
    fontSize: "24px",
    marginBottom: "10px",
  },
  subtitle: {
    fontSize: "0.9rem",
    color: "rgb(75, 85, 99)",
    textAlign: "center",
    marginBottom: "7px",
  },
  subtitlefooter: {
    fontSize: "0.9rem",
    color: "rgb(75, 85, 99)",
    textAlign: "center",
    marginTop: "1rem",
  },
  label: {
    fontWeight: "500",
    marginBottom: "6px",
    display: "block",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    marginBottom: "1rem",
    fontSize: "14px",
  },
  passwordWrapper: {
    position: "relative",
    marginBottom: "1rem",
  },
  icon: {
    position: "absolute",
    right: "10px",
    top: "45%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#6b7280",
  },
  button: {
    backgroundColor: "#facc15",
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    fontWeight: "500",
    color: "white",
    fontSize: "16px",
    width: "100%",
    cursor: "pointer",
    marginTop: "10px",
  },
  footer: {
    textAlign: "center",
    fontSize: "13px",
    color: "#4b5563",
    marginTop: "20px",
  },
  footerIcons: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginBottom: "5px",
  },
  footerText: {
    fontSize: "12px",
    color: "#9ca3af",
  },
};

export default Signup;
